module.exports = __webpack_public_path__ + "img/111.e065f765.jpg";